import {queryOptions} from '@tanstack/react-query';
import {fetchUserSelf} from './fetchUserSelf';

export const userSelfQueryOptions = () =>
  queryOptions({
    queryKey: ['users', ':self'],
    queryFn: fetchUserSelf,
    refetchOnWindowFocus: false,
  });
